export const TabTitle = (newTitle) => {
  return (document.title = newTitle + " | MAW Web Services LLC");
};
